export default __webpack_public_path__ + "static/media/goshen99.6f4131da.jpg";